import { useMemo } from "react";

import { UserRolesActionItemForBulkActions } from "./types";
import useDeleteUserRolesBulkAction from "./useDeleteUserRolesBulkAction";

const useUserRolesBulkActions = (): UserRolesActionItemForBulkActions[] => {
  const confirmDeleteUserRolesBulkAction = useDeleteUserRolesBulkAction();

  return useMemo(() => [confirmDeleteUserRolesBulkAction], [confirmDeleteUserRolesBulkAction]);
};

export default useUserRolesBulkActions;
